import React from 'react'
import css from './section.module.css'
import resources from './../../../../resources/index';
import Location from './Location';
const Section6 = () => {
  const locationData = [
    {
      image: resources.images.about_loc_1,
      name: 'Singapore',
      address: '636 Bombardier Way Sr,Worthington, California(CA), 94102',
    },
    {
      image: resources.images.about_loc_2,
      name: 'Singapore',
      address: '636 Bombardier Way Sr,Worthington, California(CA), 94102',
    },
    {
      image: resources.images.about_loc_3,
      name: 'Singapore',
      address: '636 Bombardier Way Sr,Worthington, California(CA), 94102',
    },
    {
      image: resources.images.about_loc_4,
      name: 'Singapore',
      address: '636 Bombardier Way Sr,Worthington, California(CA), 94102',
    },
  ]
  return (
    <div className={css.section6}>
      <div className={css.div1}>
        <h4>Our Office</h4>
        <h2>Located Around the World</h2>
        <p>
        Dynamically technically sound technologies with parallel task convergence quality vectors through excellent relationships.
        </p>
      </div>
      <div className={css.div2}>
        {locationData.map((data, index)=>{
          return(
            <Location key={index} data = {data} />
          )
        })}
      </div>
    </div>
  );
};
export default Section6